module.exports = __webpack_public_path__ + "static/media/website-pathutility.0bfd1f87.png";